export enum ServiceProviderConfiguredParameter {
  MediumTimerSupport = "MTIMER",
  NpacConnectionType = "DELEGATION",
  AutomatedArchivingDelay = "ARCHIVE",
  AutomatedActivationTime = "ACTIVATE",
  SvTypeSupport = "SVTYPE",
  LSRRejectedCancel ="LSRREJECTED-TO-CANCEL"
}
